import React, { memo, useEffect } from 'react';

import { Button, useDeviceType } from '@cian/ui-kit';
import { BorderBlock } from '../BorderBlock';
import { ETestIds } from '../../constants';
import { useTracking } from 'shared/mortgageMiniCalculator/utils/tracking/useTracking';

export interface ISomethingWentWrongProps {
  onRefresh: () => void;
}

const img_url = 'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_mini_calculator/tumbleweed.svg';

export const SomethingWentWrong: React.FC<ISomethingWentWrongProps> = memo(({ onRefresh }) => {
  const { trackShowErrorListing } = useTracking();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  useEffect(() => {
    trackShowErrorListing();
  }, []);

  return (
    <BorderBlock
      testId={ETestIds.SomethingWentWrong}
      imgUrl={img_url}
      title={'Что-то пошло не так'}
      description={'Проверьте интернет или попробуйте обновить'}
      button={
        <Button fullWidth={isMobile} onClick={onRefresh}>
          Обновить
        </Button>
      }
    />
  );
});

SomethingWentWrong.displayName = 'SomethingWentWrong';
